import { render, staticRenderFns } from "./ApproveTicket.vue?vue&type=template&id=9c438eda&scoped=true"
import script from "./ApproveTicket.vue?vue&type=script&lang=js"
export * from "./ApproveTicket.vue?vue&type=script&lang=js"
import style0 from "./ApproveTicket.vue?vue&type=style&index=0&id=9c438eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c438eda",
  null
  
)

export default component.exports